import React, { useEffect, useState } from 'react';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import CalendarIcon from '@material-ui/icons/CalendarToday';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ptBrLocale from 'date-fns/locale/pt-BR';
import moment from 'moment';
import { formatMoney } from '../../utils/common';

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    width: '95%',
  },
  card: {
    maxWidth: 300,
    maxHeight: 200,
    textAlign: 'center',
  },
}));

function CardCustom({ updateValue, title, value, date, type }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    updateValue(date, '');
  }, []);

  const updateDataValue = (d) => {
    setOpen(!open);
    updateValue(moment(d).format('YYYY-MM-DD'));
  };

  return (
    <Box borderRadius={16}>
      <Card className={classes.card}>
        <CardContent>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="stretch"
          >
            <Grid item xs>
              <Typography variant="h5" gutterBottom>
                {title}
              </Typography>
            </Grid>
            <Collapse in={date}>
              <Grid item>
                <IconButton
                  edge="start"
                  aria-label="delete"
                  classsize="small"
                  onClick={() => setOpen(!open)}
                >
                  <CalendarIcon fontSize="inherit" />
                </IconButton>
              </Grid>
            </Collapse>
          </Grid>
          <div align="center">
            <Typography variant="h4" gutterBottom>
              {type === 'money' ? formatMoney(value) : value}
            </Typography>
          </div>
          <Collapse in={!open && date}>
            <Typography variant="subtitle2" display="block" gutterBottom>
              {moment(date).format('MM/YYYY')}
            </Typography>
          </Collapse>
          <Collapse in={open}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBrLocale}>
              <DatePicker
                views={['year', 'month']}
                label="Mês/Ano"
                format="MM/yyyy"
                value={date}
                onChange={updateDataValue}
                InputAdornmentProps={{ position: 'start' }}
                inputVariant="outlined"
              />
            </MuiPickersUtilsProvider>
          </Collapse>
        </CardContent>
      </Card>
    </Box>
  );
}

export default CardCustom;
